import { client } from "../client";

export const setBranch = async (branchId: any) => {
  const response = await client.post("/setBranch", { branchId });

  return response.data;
};
